import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DisplayMicrosoftTeamsMessageComponent } from './display-microsoft-teams-message.component';

const routes: Routes = [
  {
    path: '',
    component: DisplayMicrosoftTeamsMessageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DisplayMicrosoftTeamsMessageRoutingModule {}
